import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

interface Props {
    children?: React.ReactNode
}

export const QueryDevtoolProvider: React.FC<Props> = ({ children }) => {
    return <ReactQueryDevtools initialIsOpen={false} />
}
